import styled from 'styled-components';

export const Content = styled.div``;

export const Item = styled.div`
  display: flex;
  margin: 0 0 5px;
`;
